export const FILTERED_CHANGE_INFO = ['filteredChangeInfo'];
export const AUDIT = ['auditParams'];
export const IS_FILTERED = ['filteredChangeInfo', 'filtered'];
export const FILTER_TYPE = ['filteredChangeInfo', '@type'];
export const CONTACT_DELETION = ['filteredChangeInfo', 'contactDeletion'];